import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-19dfb9c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column gap-2" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "text-red-500" }

import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DacklTextInput',
  props: {
    type: {},
    modelValue: {},
    label: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const error = ref<boolean>(false);

const backgroundColor = ref("white");
watch(
  () => props.disabled,
  (newValue) => {
    backgroundColor.value = newValue ? "rgba(237, 240, 243, 1)" : "white";
  },
  { immediate: true } // Run the watcher immediately on component mount
);
const id = Math.random().toString(32).substring(2);

function update(value: string): void {
  if (props.type === "number") {
    const isValidNumber = !Number.isNaN(Number(value));
    error.value = !isValidNumber;
    // Do not emit invalid values
    if (error.value) {
      return;
    }

    emit("update:modelValue", `${Number(value)}`);
    return;
  }
  emit("update:modelValue", value);
}

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "text-sm relative z-1 pl-2 text-black-alpha-70",
          for: _unref(id)
        }, _toDisplayString(_ctx.label), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(_component_InputText, {
      inputmode: _ctx.type === 'number' ? 'numeric' : 'text',
      class: "pt-5 -mt-5",
      id: _unref(id),
      value: _ctx.modelValue,
      style: _normalizeStyle({ backgroundColor: backgroundColor.value }),
      disabled: _ctx.disabled,
      onKeyup: _cache[0] || (_cache[0] = ($event: any) => (update($event.target.value)))
    }, null, 8, ["inputmode", "id", "value", "style", "disabled"]),
    _withDirectives(_createElementVNode("span", _hoisted_3, "Ungültige Eingabe", 512), [
      [_vShow, error.value]
    ])
  ]))
}
}

})